export class PlayerStats {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "PlayerStats";
    this.scene = "PlayerStats";
    this.data = [];
    this.page = 10005;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "100"; // Number
      }).value = options.team?.variables?.badge || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "102"; // Number
      }).value = options.player.first_name_upper || "";
      xml.payload.field.find((item) => {
        return item.attr.name === "103"; // Number
      }).value = options.player.last_name_upper || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "201"; // Number
      }).value = options.stats?.[0]?.category || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "301"; // Number
      }).value = options.stats?.[0]?.value || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "202"; // Number
      }).value = options.stats?.[1]?.category || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "302"; // Number
      }).value = options.stats?.[1]?.value || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "203"; // Number
      }).value = options.stats?.[2]?.category || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "303"; // Number
      }).value = options.stats?.[2]?.value || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "204"; // Number
      }).value = options.stats?.[3]?.category || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "304"; // Number
      }).value = options.stats?.[3]?.value || "";

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
